export default "__VITE_ASSET__38002163__"